import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { EventType, PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './utils/authConfig';
import { MsalProvider } from '@azure/msal-react';

/**
 * Global MSAL instance for backward compatibility and API client use
 * This will be set by DynamicMsalProvider once configuration is loaded
 */
export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL instance and handle redirect
msalInstance.initialize().then(() => {
  // Account selection logic is app dependent. Adjust as needed for your use case.
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  msalInstance.addEventCallback((event) => {
    if (
      event.eventType === EventType.LOGIN_SUCCESS &&
      event.payload &&
      'account' in event.payload
    ) {
      const account = event.payload.account;
      if (account) {
        msalInstance.setActiveAccount(account);
      }
    }
  });

  // Handle redirect promise
  msalInstance
    .handleRedirectPromise()
    .then((response) => {
      if (response) {
        console.log('Redirect response received:', response);
      }
    })
    .catch((error) => {
      console.error('Error handling redirect:', error);
    });

  // Render the app after MSAL is initialized
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
});
